import "./CreateSubscription.css";
import "../CommunityName/CommunityName.css";
import { toastify } from "../../../../helpers/toast/toastify";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Arrow from "../../../../assets/images/onboardingImages/longArrow.svg";
import CloseModal from "./CloseModal";
import CombineInput from "./CombineInput";
import CopyLogo from "../../../../assets/images/onboardingImages/logo_black.svg";
import Cross from "../../../../assets/images/onboardingImages/crossBlack.svg";
import FloatingTextFiled from "../../../sharedPages/CommonComponents/FloatingTextFiled/FloatingTextFiled";
import InfoPopup from "../../../sharedPages/CommonComponents/InfoPopup/InfoPopup";
import Modal from "react-bootstrap/Modal";
import OfferATrial from "./OfferATrial";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import CrossImg from "../../../../assets/images/onboardingImages/TierCoss.svg";
import { fetchUser } from "../../../../helpers/helper";
import { useSelector, useDispatch } from "react-redux";
import {
  resetOnBoardingStartContext,
  storeUser,
} from "../../../../redux/users/usersSlice";
import _ from "lodash";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";

const CreateSubscription = () => {
  const [currSub, setCurrSub] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTrailOption, setSelectedTrailOption] = useState("");
  const [show, setShow] = useState(true);
  const onBoardingStartContext = useSelector(
    (state) => state.user?.onBoardingStartContext
  );

  const [subscriptions, setSubscriptions] = useState([
    {
      name: "Tier 1",
      monthlyfee: "",
      yearlyfee: "",
      trialPeriodDays: "",
      tradingCapital: "",
      minimumFunding: "",
    },
  ]);

  const [alredaySubscription, setAlreadySubscription] = useState([
    {
      name: "Tier 1",
      monthlyfee: "",
      yearlyfee: "",
      trialPeriodDays: "",
      tradingCapital: "",
      minimumFunding: "",
    },
  ]);
  const [toFreeTrail, setToFreeTrail] = useState(false);
  const [warn, setWarn] = useState(false);
  const [formErrors, setFormErrors] = useState({
    monthlyfee: false,
    yearlyfee: false,
    tradingCapital: false,
    minimumFunding: false,
  });
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const api = useApi();
  const navigate = useNavigate();

  const canAddTier =
    currSub === subscriptions.length - 1 &&
    subscriptions.length < 5 &&
    subscriptions[currSub].monthlyfee &&
    subscriptions[currSub].yearlyfee &&
    subscriptions[currSub].minimumFunding;

  const showNextButton =
    subscriptions[currSub].monthlyfee &&
    subscriptions[currSub].yearlyfee &&
    subscriptions[currSub].minimumFunding;

  const trailOptions = [
    {
      label: "No trial",
      value: "0",
    },
    {
      label: "7 days ",
      value: "7",
    },
    {
      label: "14 days",
      value: "14",
    },
    {
      label: "1 Month",
      value: "30",
    },
  ];
  const isOnBoardingComplete =
  user?.onboarding?.isCommunityCreated &&
  user?.onboarding?.connect &&
  user?.onboarding?.payment &&
  user?.onboarding?.subscribed &&
  user?.onboarding?.isVerified;
  const addSubscription = () => {
    if (
      isNaN(subscriptions[currSub].monthlyfee) ||
      +subscriptions[currSub].monthlyfee < 1 ||
      +subscriptions[currSub].monthlyfee > 99999
    ) {
      setFormErrors((prev) => ({
        ...prev,
        monthlyfee: true,
      }));
      return toastify(
        "Please enter a valid positive number (1-99999) for monthly price"
      );
    }

    const tradingCapitalValue = subscriptions[currSub].tradingCapital;
    // Empty = unlimited; only validate when a value is entered
    if (
      tradingCapitalValue !== "" &&
      tradingCapitalValue != null &&
      (isNaN(tradingCapitalValue) ||
        +tradingCapitalValue < 1 ||
        +tradingCapitalValue > 99999)
    ) {
      setFormErrors((prev) => ({
        ...prev,
        tradingCapital: true,
      }));

      return toastify(
        "Please enter a valid positive number (1-99999), or leave blank for unlimited"
      );
    }

    if (
      isNaN(subscriptions[currSub].yearlyfee) ||
      +subscriptions[currSub].yearlyfee < 1 ||
      +subscriptions[currSub].yearlyfee > 99999
    ) {
      setFormErrors((prev) => ({
        ...prev,
        yearlyfee: true,
      }));

      return toastify(
        "Please enter a valid positive number (1-99999) for yearly price"
      );
    }

    if (
      isNaN(subscriptions[currSub].minimumFunding) ||
      +subscriptions[currSub].minimumFunding < 1 ||
      +subscriptions[currSub].minimumFunding > 99999
    ) {
      setFormErrors((prev) => ({
        ...prev,
        minimumFunding: true,
      }));

      return toastify(
        "Please enter a valid positive number (1-99999) for minimumFunding price"
      );
    }

    setSubscriptions([
      ...subscriptions,
      {
        name: `Tier ${subscriptions.length + 1}`,
        monthlyfee: "",
        yearlyfee: "",
        trialPeriodDays: "",
        tradingCapital: "",
        minimumFunding: "",
      },
    ]);
    setCurrSub(subscriptions.length);
  };

  const removeSubscription = () => {
    if (subscriptions.length <= 1) {
      return toastify("You must have at least one subscription tier.");
    }

    const newSubscriptions = subscriptions.slice(0, -1);
    setSubscriptions(newSubscriptions);

    // If the current selected subscription was the last one, adjust the index
    if (currSub >= newSubscriptions.length) {
      setCurrSub(newSubscriptions.length - 1);
    }
  };

  const handleClose = () => {
    if (onBoardingStartContext) {
      setShow(false);
      dispatch(resetOnBoardingStartContext());
      navigate(onBoardingStartContext, { replace: true });
      return;
    }
    navigate("/leader/dashboard", { replace: true });
    setShow(false);
  };

  const handleNext = () => {
    const MAX_VALUE = 99999;
    const MIN_VALUE = 1;

    const isValidSubscriptions = subscriptions.every((subscription) => {
      const monthlyFee = +subscription.monthlyfee;
      if (
        isNaN(monthlyFee) ||
        monthlyFee < MIN_VALUE ||
        monthlyFee > MAX_VALUE
      ) {
        setFormErrors((prev) => ({
          ...prev,
          monthlyfee: true,
        }));

        toastify(
          `Please enter a valid positive number (${MIN_VALUE}-${MAX_VALUE}) for monthly price in ${subscription.name}`
        );
        return false;
      }

      const tradingCapital = subscription.tradingCapital;
      // Empty = unlimited; only validate when a value is entered
      if (
        tradingCapital !== "" &&
        tradingCapital != null &&
        (isNaN(+tradingCapital) ||
          +tradingCapital < MIN_VALUE ||
          +tradingCapital > MAX_VALUE)
      ) {
        setFormErrors((prev) => ({
          ...prev,
          tradingCapital: true,
        }));

        toastify(
          `Please enter a valid positive number (${MIN_VALUE}-${MAX_VALUE}) for trading capital in ${subscription.name}, or leave blank for unlimited`
        );
        return false;
      }

      const yearlyFee = +subscription.yearlyfee;
      if (isNaN(yearlyFee) || yearlyFee < MIN_VALUE || yearlyFee > MAX_VALUE) {
        setFormErrors((prev) => ({
          ...prev,
          yearlyfee: true,
        }));

        toastify(
          `Please enter a valid positive number (${MIN_VALUE}-${MAX_VALUE}) for yearly price in ${subscription.name}`
        );
        return false;
      }

      const minFundingNum = +subscription.minimumFunding;
      if (
        isNaN(minFundingNum) ||
        minFundingNum < MIN_VALUE ||
        minFundingNum > MAX_VALUE
      ) {
        setFormErrors((prev) => ({
          ...prev,
          minimumFunding: true,
        }));

        toastify(
          `Please enter a valid positive number (${MIN_VALUE}-${MAX_VALUE}) for minimum funding`
        );
        return false;
      }

      return true;
    });

    if (isValidSubscriptions) setToFreeTrail(true);
  };

  const handleSubmission = async () => {
    const isEqual = _.isEqual(subscriptions, alredaySubscription);

    if (isEqual) {
      navigate("/leader/onboarding/payout", { replace: true });
      return;
    }

    setIsLoading(true);

    try {
      const apires = await api(
        "post",
        "authorizeNewonBoard/createSubscriptions",
        {
          subscriptions: subscriptions.map((sub) => ({
            ...sub,
            tradingCapital:
              sub.tradingCapital === "" ||
              sub.tradingCapital == null ||
              String(sub.tradingCapital).toUpperCase() === "UNLIMITED"
                ? "UNLIMITED"
                : sub.tradingCapital,
          })),
        }
      );

      if (apires?.status) {
         const responseUser = await api("get", "users/index");

        if (responseUser?.status) {
          const { data } = responseUser;
          if (dispatch && storeUser) dispatch(storeUser(data));
          if (data?.token) localStorage.setItem("token", data.token);
          // return data;
        }
        // await fetchUser(api, dispatch, storeUser);

        navigate("/leader/onboarding/payout", { replace: true });
      } else {
        toastify(apires?.message, "error");
      }
    } catch (error) {
      console.error("🚀 -> handleSubmission -> error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const updateSubscription = (field, value) => {
    setSubscriptions((prevSubscriptions) =>
      prevSubscriptions.map((subscription, index) =>
        index === currSub ? { ...subscription, [field]: value } : subscription
      )
    );
  };
  useEffect(()=>{
    if((isOnBoardingComplete&&user?.leaderCommunity)||(!user?.leaderCommunity)){
      navigate("/leader/dashboard", { replace: true });
      return;
     }
  
     if(!isOnBoardingComplete&&user?.leaderCommunity&&!user?.onboarding?.connect){
      navigate("/leader/onboarding/connection", { replace: true });
      return;
    }
  },[])
  useEffect(() => {
    if (selectedTrailOption) {
      const trail = trailOptions.filter(
        (option) => option.label === selectedTrailOption
      )[0];

      setSubscriptions((prevSubscriptions) =>
        prevSubscriptions.map((subscription) => ({
          ...subscription,
          trialPeriodDays: trail.value,
        }))
      );
    }
  }, [selectedTrailOption]);

  // useEffect(() => {
  //   if (user?.role === "leader") {
  //     if (!user?.onboarding?.isCommunityCreated) {
  //       navigate("/leader/onboarding/community", { replace: true });
  //       return;
  //     }

  //     if (!user?.onboarding?.connect) {
  //       navigate("/leader/onboarding/connection", { replace: true });
  //       return;
  //     }

  //     if (!user?.onboarding?.subscribed) {
  //       navigate("/leader/onboarding/subscription", { replace: true });
  //       return;
  //     }

  //     if (!user?.onboarding?.payment) {
  //       navigate("/leader/onboarding/payout", { replace: true });
  //       return;
  //     }

  //     if (!user?.onboarding?.isVerified) {
  //       if (user?.socialLogin?.discord?.id) {
  //         navigate("/leader/onboarding/importantUpdates", { replace: true });
  //       } else if (user?.socialLogin?.telegram?.id) {
  //         navigate("/leader/onboarding/submitNewEmail", { replace: true });
  //       } else {
  //         navigate("/leader/onboarding/verify", { replace: true });
  //       }
  //       return;
  //     }
  //   }
  // }, []);

  useEffect(() => {
    if (user?.leaderCommunity?.subscription?.length) {
      // Show blank in the UI for unlimited; API still stores "UNLIMITED"
      const normalized = user.leaderCommunity.subscription.map((sub) => ({
        ...sub,
        tradingCapital:
          !sub.tradingCapital ||
          String(sub.tradingCapital).toUpperCase() === "UNLIMITED"
            ? ""
            : sub.tradingCapital,
      }));
      setSubscriptions(normalized);
      setAlreadySubscription(normalized);
    }
  }, []);
 
  return (
    <>
      <div className="onboarding-modal-wrapper">
        <Modal
          animation={false}
          backdropClassName="onboarding-custom-backdrop"
          centered
          dialogClassName="custom-onboarding-modal"
          show={show}
        >
          <Modal.Body className="figma-drop-shadow">
            <button
              className="reverseArrow"
              onClick={() => {
                if (toFreeTrail) {
                  setSelectedTrailOption("");
                  setToFreeTrail(false);
                } else
                  navigate("/leader/onboarding/connection", { replace: true });
              }}
              type="button"
            >
              <img alt="" src={Arrow} />
            </button>
            <button
              className="CrossIcon"
              onClick={() => {
                if (toFreeTrail) setWarn(true);
                else handleClose();
              }}
              type="button"
            >
              <img alt="" src={Cross} />
            </button>
            {toFreeTrail ? (
              <OfferATrial
                handleSubmission={handleSubmission}
                isLoading={isLoading}
                options={trailOptions.map((option) => option.label)}
                selectedOption={selectedTrailOption}
                setSelectedOption={setSelectedTrailOption}
              />
            ) : (
              <div className="onboardingContentBox CreateSubscriptionPage">
                <h2 className="title">
                  <span>Create Subscription</span>
                  {/* <a style="color: white;" href="https://stripe.com" target="_blank" rel="noopener noreferrer">
  Stripe | Financial Infrastructure to Grow Your Revenue
</a> */}
                  <InfoPopup
                    contentItems={[
                      { text: "Create subscription", type: "heading" },
                      {
                        text: `Define your subscription tiers to launch your service.
You set the price per member, and we add a $15 platform fee per member per month.

You can create tiers based on maximum trading capital, allowing you to charge more for larger accounts. Members are billed once per month or year. All payments are securely handled by Stripe.

`,
                        type: "paragraph",
                      },
                    ]}
                  />
                </h2>
                <p className="desc">Define your Subscription plan(s)</p>
                <div className="tierBtnBox">
                  {subscriptions.map((subscription, i) => (
                    <div className="tierBtnBoxInner">
                      <button
                        className={`tierBtn ${currSub === i && "active"}`}
                        key={i}
                        onClick={() => setCurrSub(i)}
                        type="button"
                      >
                        {subscription.name}
                      </button>
                      {i === subscriptions.length - 1 && i !== 0 && (
                        <button
                          type="button"
                          className="CrossImg"
                          onClick={removeSubscription}
                        >
                          <img src={CrossImg} alt="" />
                        </button>
                      )}
                    </div>
                  ))}
                </div>
                <div className="formBox">
                  <div className="mb-20px">
                    <CombineInput
                      subscription={subscriptions[currSub]}
                      updateSubscription={updateSubscription}
                      formErrors={formErrors}
                      className="onboardingCombineInput"
                    />
                    <p className="combineInputBtmText">
                      Members are billed{" "}
                      <strong>
                        $
                        {+subscriptions[currSub].monthlyfee <= 99999
                          ? (+subscriptions[currSub].monthlyfee + 15).toFixed(2)
                          : "15.00"}
                      </strong>{" "}
                      monthly /{" "}
                      <strong>
                        $
                        {+subscriptions[currSub].yearlyfee <= 99999
                          ? (+subscriptions[currSub].yearlyfee + 180).toFixed(2)
                          : "180.00"}
                      </strong>{" "}
                      yearly
                    </p>
                  </div>
                  <div className="mb-20px">
                    <FloatingTextFiled
                      className={`onboardingInput ${
                        formErrors.minimumFunding && "invalid"
                      }`}
                      label="Minimum Funding"
                      onChange={(e) => {
                        
                        let value = e.target.value.replace(/[^0-9.]/g, "");
                        value = value.replace(/(\..*)\./g, "$1");
                        if (value > 99999) {
                          toastify("Please add value between 1-99999");
                          return;
                        }
                        updateSubscription("minimumFunding", value);
                      }}
                      placeholder="Minimum Funding"
                      value={subscriptions[currSub].minimumFunding?`$${subscriptions[currSub].minimumFunding}`:""}
                    />
                  </div>
                  <div className="mb-20px">
                    <FloatingTextFiled
                      className={`onboardingInput mb-6px ${
                        formErrors.tradingCapital && "invalid"
                      }`}
                      label="Maximum Trading Capital"
                      onChange={(e) => {
                        let value = e.target.value.replace(/[^0-9.]/g, "");
                        value = value.replace(/(\..*)\./g, "$1");
                        if (value > 99999) {
                          toastify("Please add value between 1-99999");
                          return;
                        }
                        updateSubscription("tradingCapital", value);
                      }}
                      placeholder="Maximum Trading Capital"
                      value={
                        subscriptions[currSub].tradingCapital
                          ? `$${subscriptions[currSub].tradingCapital}`
                          : ""
                      }
                    />
                    <p className="maxTradeTextOnBoarding">
                      Leave blank for unlimited
                    </p>
                  </div>
                  <div className="d-flex flex-column gap-20 align-items-center mb-20px">
                    {canAddTier && (
                      <div>
                        <BubbleSvgButton
                          className="ExtraTierBtn"
                          onClick={addSubscription}
                          text={"Add extra tier"}
                          type="button"
                          variant="black"
                          containerStyling={{
                            justifyContent: "center",
                          }}
                          mainDivStyle={{
                            width: "275px",
                            height: "55px",
                          }}
                        />
                      </div>
                    )}
                    {showNextButton && (
                      <BubbleSvgButton
                        className="NextBtn"
                        onClick={handleNext}
                        text={"Next"}
                        type="button"
                        variant="black"
                        containerStyling={{
                          justifyContent: "center",
                        }}
                        mainDivStyle={{
                          width: "275px",
                          height: "55px",
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
            <div className="paginationDots">
              <button className="dot"></button>
              <button className="dot"></button>
              <button className="dot"></button>
              <button className={`dot ${!toFreeTrail && "active"}`}></button>
              <button className={`dot ${toFreeTrail && "active"}`}></button>
              <button className="dot"></button>
              <button className="dot"></button>
              <button className="dot"></button>
            </div>
            {/* <div className="copyrightBox">
              <p className="">
                Powered by{" "}
                <span className="spanMain">
                  <img src={CopyLogo} alt="" />
                </span>
              </p>
            </div> */}
          </Modal.Body>
        </Modal>
      </div>

      {warn && (
        <CloseModal
          handleClose={handleClose}
          setWarn={setWarn}
          warn={warn}
          subText={"If you close now your Tiers will be lost!"}
        />
      )}
    </>
  );
};

export default CreateSubscription;
